import { gql } from "@apollo/client";

export const DELETE_RI_EV = gql`
mutation deleteRIEV(    
    $data: RIEVMedicoDeleteInput!){
    deleteRIEVMedico(
        data: $data
    ) {
        success,
        error,
        valorEsperado
    }
}
`;